import { Badge } from '@/components/ui/badge.jsx';
import { formatCurrency } from '@/lib/format.js';

// Shared right-rail primitives for the deal + account workspaces (Task I.2/I.3,
// workspace mockups). Pure presentational kv/stat rows on the shell rail.

export function Section({ title, children }) {
  return (
    <div className="border-t border-border px-3.5 py-3.5 first:border-t-0">
      <h3 className="mb-2.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-text-dim">
        {title}
      </h3>
      {children}
    </div>
  );
}

export function Head({ name, badge, onClick }) {
  return (
    <div className="mb-2 flex items-center justify-between gap-2">
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          className="truncate text-left text-[13px] font-semibold text-cream hover:underline"
        >
          {name}
        </button>
      ) : (
        <span className="truncate text-[13px] font-semibold text-cream">{name}</span>
      )}
      {badge ? (
        <Badge variant="outline" className="shrink-0 text-[10px]">
          {badge}
        </Badge>
      ) : null}
    </div>
  );
}

export function KV({ k, v, onClick }) {
  if (v == null || v === '' || v === '—') return null;
  return (
    <div className="flex justify-between gap-3 py-[3px] text-[11.5px]">
      <span className="text-text-dim">{k}</span>
      {onClick ? (
        <button type="button" onClick={onClick} className="truncate text-right text-text hover:underline">
          {v}
        </button>
      ) : (
        <span className="text-right tabular-nums text-text">{v}</span>
      )}
    </div>
  );
}

export function RailStat({ label, value, delta, accent }) {
  return (
    <div className="mb-3 last:mb-0">
      <div className="text-[10px] font-medium uppercase tracking-wider text-text-dim">{label}</div>
      <div className={`mt-0.5 text-[15px] font-semibold ${accent ? 'text-success' : 'text-text'}`}>
        {value}
      </div>
      {delta ? <div className="text-[10.5px] text-text-dim">{delta}</div> : null}
    </div>
  );
}

// Render a value as currency when numeric; passes through percentage strings.
export function money(v) {
  if (v == null || v === '') return null;
  if (typeof v === 'string' && v.includes('%')) return v;
  return isNaN(Number(v)) ? v : formatCurrency(v);
}
